import { Component, OnInit } from "@angular/core";
import { ChartBindingObject } from "@tylertech/charting-module";
import { isErroredExecutionResult, isHttpResponseError, ToastService } from "@tylertech/core-module";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { Utilities } from "@tylertech/shared-module";
import { InBalanceManagerService, InBalanceService, IndexedProvider } from "../../services";

@Component({
    selector: "in-balance-card",
    templateUrl: "./inBalance.tmpl.html",
    standalone: false
})
export class InBalanceComponent implements OnInit, ICustomViewComponent<ChartBindingObject>
{
    readonly customDataBinding: ChartBindingObject;
    loaded: boolean = false;

    hasChecks: boolean = false;

    constructor(
        private $toastService: ToastService,
        private readonly $inBalanceService: InBalanceService,
        private readonly $inBalanceManagerService: InBalanceManagerService)
    { }

    ngOnInit(): void
    {
        this.$inBalanceService.GetRegisteredChecks()
            .then(
                (result: string[]) =>
                {
                    this.$inBalanceManagerService.Sorted = [];
                    result.forEach(provider =>
                    {
                        this.$inBalanceManagerService.Sorted.push({
                            ProviderId: provider,
                            Index: 0,
                        });
                    });
                    this.hasChecks = !Utilities.IsNullOrUndefined(result) && result.length > 0;
                },
                (error: unknown) =>
                {
                    if (isErroredExecutionResult(error))
                    {
                        this.$toastService.showToast(error.ErrorMessage);
                    }
                    else if (isHttpResponseError(error))
                    {
                        this.$toastService.showToast(error.error.Message);
                    }
                    else
                    {
                        this.$toastService.showToast("An Error occurred.");
                        console.error(error, new Error("An Error occurred."));
                    }
                }).
            finally(() =>
            {
                this.loaded = true;
            });
    }

    get sortedProviders(): IndexedProvider[]
    {
        return this.$inBalanceManagerService.Sorted.sort((o1, o2): number =>
        {
            if (!o1 && !o2) return 0;
            if (o1 && !o2) return 1;
            if (!o1 && o2) return -1;
            return o1.Index - o2.Index;
        });
    }
}
